import { motion, Variants } from "framer-motion";
import React from "react";
import styled from "styled-components";
import { TGetServicesCollectionItem } from "../../../../../../api/service/service.types";
import ServiceCard from "../../../../features/service/components/ServiceCard";

const StyledServiceWrapper = styled.div`
  margin-bottom: 1rem;
`;

const listVariants: Variants = {
  enter: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delay: 0.1,
    },
  },
  exit: {
    opacity: 0,
  },
};

const itemVariants: Variants = {
  enter: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.25 },
  },
  exit: {
    opacity: 0,
    y: 15,
    transition: { duration: 0.1 },
  },
};

interface IServicesListProps {
  services: TGetServicesCollectionItem[];
  isLoading: boolean;
  onDelaySet: () => void;
}

const ServicesList = (props: IServicesListProps) => {
  const { services, onDelaySet } = props;
  return (
    <motion.div initial="exit" animate="enter" variants={listVariants}>
      {services.map((service) => {
        return (
          <motion.div key={service.id} variants={itemVariants}>
            <StyledServiceWrapper>
              <ServiceCard onDelaySet={onDelaySet} service={service} />
            </StyledServiceWrapper>
          </motion.div>
        );
      })}
    </motion.div>
  );
};

export default ServicesList;
